
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2 7h28v7h-1c-1.19 0-2 .81-2 2s.81 2 2 2h1v7H2v-7h1c1.19 0 2-.81 2-2s-.81-2-2-2H2V7zm2 2v3.188c1.715.451 3 1.955 3 3.813s-1.285 3.362-3 3.813v3.188h24v-3.188c-1.715-.451-3-1.955-3-3.813s1.285-3.362 3-3.813V9H4z"}})])
          )
        }
      }
    